import { useState } from "react";

import { Popover, PopoverContent, PopoverTrigger } from "../../../popover";
import { Input } from "../../../input";
import { Button } from "../../../button";

import { isValidUrl } from "@/utils/utils";

interface LinkEditFormProps {
  data: string;
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
  saveData?: (newData: string, previousData: string, index?: number) => void;
}

export const LinkEditForm = ({ data, isEditing, setIsEditing, saveData }: LinkEditFormProps) => {
  const [link, setLink] = useState<string>(data);

  return (
    <Popover open={isEditing} onOpenChange={setIsEditing}>
      <PopoverTrigger asChild>
        <div className="absolute inset-0 -z-[1000]" />
      </PopoverTrigger>
      <PopoverContent className="w-auto max-w-[600px] p-0" side="top">
        <div className="space-y-3 p-4">
          <h3 className="text-base font-semibold text-gray-900">Edit Link</h3>
          <div className="w-full min-w-[320px] space-y-4">
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700">URL Address</label>
              <Input
                type="url"
                value={link}
                onChange={e => setLink(e.target.value.slice(0, 100))}
                placeholder="https://example.com"
                className="w-full border-gray-300 font-mono text-sm transition-all focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
              />
            </div>

            <div className="flex items-center justify-between gap-3">
              <div className="flex gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => {
                    setLink(data);
                    setIsEditing(false);
                  }}
                  className="border-gray-300 text-gray-700 transition-colors hover:border-gray-400 hover:bg-gray-50"
                >
                  Cancel
                </Button>
                <Button
                  size="sm"
                  onClick={() => {
                    saveData?.(link, data);
                    setIsEditing(false);
                  }}
                  disabled={link === data || !isValidUrl(link)}
                  className="bg-blue-600 text-white shadow-sm transition-all hover:bg-blue-700 hover:shadow-md disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-blue-600 disabled:hover:shadow-sm"
                >
                  Save Changes
                </Button>
              </div>
            </div>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
